/**
 * Types for user feedback reactions.
 * Backend mirror: src/space_operator/models/feedback.py
 * Contract locked: FEEDBACK_COMMENT_MAX must match Pydantic + SQL CHECK.
 */

export const FEEDBACK_COMMENT_MAX = 10000

export type FeedbackRating = 'up' | 'down'

/** Wire-format reaction (as returned by the server and stored in chat-history state). */
export interface FeedbackReaction {
  rating: FeedbackRating
  comment: string | null
  updated_at: string
}

export interface FeedbackTarget {
  sessionId: string
  /** null = session-level reaction. */
  messageId: string | null
}

/** Key used in the pendingMap to distinguish message-level vs session-level entries. */
export const SESSION_REACTION_KEY = '__session__'

export function reactionKey(messageId: string | null): string {
  return messageId ?? SESSION_REACTION_KEY
}
